import {Routes} from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { OverviewComponent } from './components/overview/overview.component';
import { StatementComponent } from './components/statement/statement.component';
import { StatementListComponent } from './components/statement/statement-list/statement-list.component';
import { StatementViewComponent } from './components/statement/statement-view/statement-view.component';
import { TransferComponent } from './components/transfer/transfer.component';
import { TransferEditComponent } from './components/transfer/transfer-edit/transfer-edit.component';
import { RecurrentComponent } from './components/recurrent/recurrent.component';
import { RecurrentListComponent } from './components/recurrent/recurrent-list/recurrent-list.component';
import { RecurrentViewComponent } from './components/recurrent/recurrent-view/recurrent-view.component';
import { CategoryComponent } from './components/category/category.component';
import { CategoryListComponent } from './components/category/category-list/category-list.component';
import { InitComponent } from './components/init/init.component';
import { SigninComponent } from './components/signin/signin.component';
import { ChangeMailComponent } from './components/change-mail/change-mail.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';

import { AuthGuard } from './guards/auth.guard';
import { InitGuard } from './guards/init.guard';

export const appRoutes: Routes = [
    {
        path: '',
        component: HomeComponent,
        canActivate: [AuthGuard, InitGuard],
        children: [
            {path: '', component: OverviewComponent},
            {
                path: 'statement',
                component: StatementComponent,
                children: [
                    {path: '', component: StatementListComponent},
                    {path: ':id', component: StatementViewComponent}
                ]
            },
            {
                path: 'transfer',
                component: TransferComponent,
                children: [
                    {path: ':id', component: TransferEditComponent}
                ]
            },
            {
                path: 'recurrent',
                component: RecurrentComponent,
                children: [
                    {path: '', component: RecurrentListComponent},
                    {path: ':id', component: RecurrentViewComponent}
                ]
            },
            {
                path: 'category',
                component: CategoryComponent,
                children: [
                    {path: '', component: CategoryListComponent}
                ]
            }
        ]
    },
    {path: 'login', component: LoginComponent},
    {path: 'signin', component: SigninComponent},
    {path: 'forgot-password', component: ForgotPasswordComponent},
    {path: 'init', component: InitComponent, canActivate: [AuthGuard]},
    {path: 'change-mail', component: ChangeMailComponent, canActivate: [AuthGuard]},
    {path: '**', component: HomeComponent, canActivate: [AuthGuard, InitGuard]}
]
